import type { VisibleUserCartMultiCartSummary } from './multiCartVisibility'
import { isDefaultMultiCart } from './multiCartVisibility'

export interface UserCartView {
  viewId: string
  view: App.MultiCartView
  cart: VisibleUserCartMultiCartSummary
  name: string
}

export function getUserCartViews(carts: Array<VisibleUserCartMultiCartSummary>, splitDefault: boolean, previouslyViewedLabel: string): Array<UserCartView> {
  const orderedCarts = [...carts].sort((first, second) => Number(isDefaultMultiCart(second)) - Number(isDefaultMultiCart(first)))
  const views = orderedCarts.map(cart => ({ viewId: cart.cartId, view: 'cart' as const, cart, name: cart.name }))
  const defaultCart = orderedCarts.find(isDefaultMultiCart)
  if (!splitDefault || !defaultCart) return views
  return [{ viewId: `previously-viewed:${defaultCart.cartId}`, view: 'previously-viewed', cart: defaultCart, name: previouslyViewedLabel }, ...views]
}

export function getCartViewItems(items: Array<App.MultiCartItem>, cart: App.MultiCartSummary | undefined, view: App.MultiCartView, splitDefault: boolean): Array<App.MultiCartItem> {
  if (!splitDefault || !isDefaultMultiCart(cart)) return items
  return items.filter(item => view === 'previously-viewed' ? item.intent === 'automatic' : item.intent !== 'automatic')
}
